import {Accordion, AccordionButton, AccordionItem, AccordionPanel,} from '@chakra-ui/react'
import "./customaccordion.scss"
import ArrowIcon from "../../modules/icons/arrow";

interface ICustomAccordion {
    title: string
    body: string
}

const CustomAccordion = ({title, body}: ICustomAccordion) => {
    return (
        <div className="Custom-Accordion">
            <Accordion allowMultiple>
                <AccordionItem>
                    <AccordionButton>
                        {title}
                        <ArrowIcon/>
                    </AccordionButton>
                    <AccordionPanel pb={4}>
                        {body}
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </div>
    )
}

export default CustomAccordion